import {VWCarModel} from '../../types/surveyResponse';

export const IFRAME_SRC = 'https://aus.volkswagen.com.au/app/locals/test-drive';

export const REGISTER_YOUR_INTEREST_MODELS: Record<VWCarModel, string> = {
  id4: 'ID.4-pro',
  id5: 'id-5-pro',
  id4Andid5: 'ID.4-pro,ID.5-gtx',
  id4gtx: 'id-4-gtx',
  id5gtx: 'ID.5-gtx',
  id4gtxAndid5gtx: 'id-4-gtx,id-5-gtx',
  amarok: 'Amarok',
  idBuzz5: 'ID.buzz',
  idBuzz7: 'ID.buzz',
  idBuzzCargo: 'ID.buzz-cargo',
  touareg: 'touareg-r-ehybrid',
};
